module.exports = "/fonts/vendor/vue-pdf-app/dist/icons/pdf.woff?fa070dcc71d7190e8c4444d72fa60db7";